import React from "react";
import ErrorPageWrapper from "./page-wrapper";
const DefaultErrorPage = () => {
    return React.createElement(ErrorPageWrapper, { handleLogout: () => { }, reloadPage: true });
};
export default DefaultErrorPage;
